module.exports = require("./hu.js");